module.exports = __webpack_public_path__ + "static/media/atm.d046217e.svg";